export const PAGE_SIZE_OPTIONS = [10, 20, 50];
export const EXECUTIVE_MAPPING_MIN_COVERAGE_PCT = 98;
export const LAST_COMPANY_STORAGE_KEY = 'projects_cost_last_company_id';

export const formatCurrencyFromCents = (value?: number | null): string => {
  const cents = Number(value || 0);
  const brl = cents / 100;
  return brl.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const formatOptionalCurrencyFromCents = (value?: number | null): string => {
  if (value == null) return '—';
  return formatCurrencyFromCents(value);
};

export const formatHours = (value?: number | null): string => {
  const num = Number(value || 0);
  return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatPercent = (value?: number | null): string => {
  if (value == null || Number.isNaN(value)) return '—';
  return `${Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
};

export const phaseVariant = (status: string): string => {
  const text = (status || '').toLowerCase();
  if (['homolog', 'atras', 'risco', 'imped', 'crític', 'critic'].some((token) => text.includes(token))) return 'danger';
  if (['conclu', 'estabil', 'done', 'fechado'].some((token) => text.includes(token))) return 'success';
  if (['aprova', 'desenvolv', 'teste', 'release'].some((token) => text.includes(token))) return 'warning';
  return 'secondary';
};

export const truncateText = (value: string, maxLength = 80): string => {
  if (!value) return '';
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength).trimEnd()}...`;
};

export const centsToReaisInput = (value?: number | null): string => {
  if (value == null) return '';
  return (Number(value) / 100).toFixed(2).replace('.', ',');
};

export const parseReaisToCents = (value: string): number | null => {
  const raw = (value || '').trim();
  if (!raw) return null;
  const normalized = raw
    .replace(/[R$\s]/g, '')
    .replace(/\./g, '')
    .replace(',', '.');
  const amount = Number(normalized);
  if (!Number.isFinite(amount) || amount < 0) return null;
  return Math.round(amount * 100);
};

const normalizeSearchValue = (value: string): string => (
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
);

export const matchesSearchTokens = (query: string, values: Array<string | number | null | undefined>): boolean => {
  const normalizedQuery = normalizeSearchValue(query.trim());
  if (!normalizedQuery) return true;
  const tokens = normalizedQuery.split(/\s+/).filter(Boolean);
  const haystack = normalizeSearchValue(values.filter((item) => item != null).join(' '));
  return tokens.every((token) => haystack.includes(token));
};

export const paginateItems = <T,>(items: T[], page: number, pageSize: number) => {
  const safePageSize = Math.max(1, pageSize);
  const totalPages = Math.max(1, Math.ceil(items.length / safePageSize));
  const currentPage = Math.min(Math.max(1, page), totalPages);
  const start = (currentPage - 1) * safePageSize;
  return {
    pageItems: items.slice(start, start + safePageSize),
    totalItems: items.length,
    totalPages,
    currentPage,
  };
};

export const getCompanyMappingPercent = (
  companyCollaborators: Array<{ jira_account_id?: string | null; jira_display_name?: string | null; is_active?: boolean }>,
): number => {
  const active = companyCollaborators.filter((item) => item.is_active !== false);
  if (active.length === 0) return 0;
  const mapped = active.filter(
    (item) => Boolean((item.jira_account_id || '').trim()) || Boolean((item.jira_display_name || '').trim()),
  );
  return (mapped.length / active.length) * 100;
};
